/**
 * * Модель запроса на удаление задачи
 */
export default class TaskRemoveRequest  {
	/**
	 * * Номер задачи
	 */
	TaskId!: number;
	constructor(obj?: Partial<TaskRemoveRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
